import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import ApiClient from 'ApiClient';

const IsDisplayInUi = ({ record, updateRecordFunction }) => {
  const key = 'displayInUi';

  const aValues = { Yes: 'Yes', No: 'No' };

  const rowData = record.params;
  const val = (typeof rowData !== 'undefined' && typeof rowData[key] !== 'undefined') ? rowData[key] : 'No';
  const [value, setValue] = useState(val);
  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState(null);
  const options = Object.keys(aValues).map(k => ({ value: k, label: aValues[k] }));
  useEffect(() => {
    setValue(val);
  }, [record]);

  const handleChange = async (option) => {
    setDisabled(true);
    setError(null);
    setValue(option.value);
    const data = new FormData();
    data.append(key, option.value);
    const api = new ApiClient();
    try {
      await api.recordAction({
        resourceId: 'Advertiser',
        recordId: record.id,
        actionName: 'edit',
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      updateRecordFunction(record.id, { displayInUi: option.value });
    } catch (e) {
      setError(e.message);
      setDisabled(false);
    }
    setDisabled(false);
    return true;
  };
  return (
    <div style={{ minWidth: '100px', maxWidth: '100px' }} >
      <Select
        value={options.find(option => option.value === value)}
        options={options}
        onChange={handleChange}
        placeholder="Display in UI"
        isDisabled={disabled}
        menuPlacement="auto"
        menuPortalTarget={document.body}
      />
      {error ? (<span className="text-danger">{error}</span>) : null}
    </div>
  );
};

IsDisplayInUi.propTypes = {
  record: PropTypes.objectOf(PropTypes.any).isRequired,
  // updateRecordFunction: PropTypes.func.isRequired,
};
export default IsDisplayInUi;
